"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var vue_property_decorator_1 = require("vue-property-decorator");
var components = {};
var AddressInput = /** @class */ (function (_super) {
    __extends(AddressInput, _super);
    function AddressInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {
            street: "",
            street2: "",
            city: "",
            state: "",
            zip: ""
        };
        return _this;
    }
    AddressInput.prototype.onFormChanged = function (to, from) {
        this.$emit('change', this.form);
    };
    Object.defineProperty(AddressInput.prototype, "streetError", {
        get: function () {
            return this.pageErrorKey && this.$page.props.errors[this.pageErrorKey + ".street"] ? this.$page.props.errors[this.pageErrorKey + ".street"] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressInput.prototype, "street2Error", {
        get: function () {
            return this.pageErrorKey && this.$page.props.errors[this.pageErrorKey + ".street2"] ? this.$page.props.errors[this.pageErrorKey + ".street2"] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressInput.prototype, "cityError", {
        get: function () {
            return this.pageErrorKey && this.$page.props.errors[this.pageErrorKey + ".city"] ? this.$page.props.errors[this.pageErrorKey + ".city"] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressInput.prototype, "stateError", {
        get: function () {
            return this.pageErrorKey && this.$page.props.errors[this.pageErrorKey + ".state"] ? this.$page.props.errors[this.pageErrorKey + ".state"] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AddressInput.prototype, "zipError", {
        get: function () {
            return this.pageErrorKey && this.$page.props.errors[this.pageErrorKey + ".zip"] ? this.$page.props.errors[this.pageErrorKey + ".zip"] : undefined;
        },
        enumerable: false,
        configurable: true
    });
    AddressInput.prototype.beforeMount = function () {
        this.form.street = lodash_1.default.clone(this.address.street);
        this.form.street2 = lodash_1.default.clone(this.address.street2);
        this.form.city = lodash_1.default.clone(this.address.city);
        this.form.state = lodash_1.default.clone(this.address.state);
        this.form.zip = lodash_1.default.clone(this.address.zip);
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Object })
    ], AddressInput.prototype, "address", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Array })
    ], AddressInput.prototype, "states", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: false, type: String })
    ], AddressInput.prototype, "pageErrorKey", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)('form', { immediate: true, deep: true })
    ], AddressInput.prototype, "onFormChanged", null);
    AddressInput = __decorate([
        vue_property_decorator_1.Component
    ], AddressInput);
    return AddressInput;
}(vue_property_decorator_1.Vue));
exports.default = AddressInput;
